<template>
  <div class="page-wrapper">
    <div class="page-head">

      <div class="breadcrumbs">
        <div class="h1" v-if="$route.path.includes('bookkeeping')">
          <router-link class="link-not-like" to="/bookkeeping">{{ $vuetify.lang.t('$vuetify.menu.accounting') }}
          </router-link>
        </div>
        <svg v-if="$route.path.includes('bookkeeping')" width="9" height="15" viewBox="0 0 9 15" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M1.27539 13.7068L7.48229 7.49989L1.27539 1.29299" stroke="#2C1521" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <h1>{{ $vuetify.lang.t('$vuetify.menu.timings') }}</h1>
        <svg v-if="name" width="9" height="15" viewBox="0 0 9 15" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M1.27539 13.7068L7.48229 7.49989L1.27539 1.29299" stroke="#2C1521" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="h1" v-if="name">
          {{ name }}
        </div>
      </div>

      <div class="page-head__btns">
        <BookkeepingSelect v-if="$route.path.includes('bookkeeping')" :mode="'documents-timings'"></BookkeepingSelect>
        <button v-if="!object && !$route.path.includes('bookkeeping') && active"
                class="btn-secondary btn"
                @click="action = 'add';timing_create_open()">
          + {{ $vuetify.lang.t('$vuetify.timings.add') }}
        </button>
      </div>

    </div>
    <button class="btn-secondary btn" @click="clearFilters">
      {{ $vuetify.lang.t('$vuetify.main.see_all') }}
    </button>
    <div class="page-head">
      <div class="page__sorts">
        <v-menu ref="date" v-model="menus.date"
                :close-on-content-click="false" transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field class="search-field" :value="range.join(' ~ ')"
                          @keypress.enter="loadData()" prepend-inner-icon="$calendar"
                          :placeholder="$vuetify.lang.t('$vuetify.date')" outlined
                          hide-details v-bind="attrs" v-on="on" readonly>
            </v-text-field>
          </template>
          <v-date-picker v-model="range" no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                         show-adjacent-months
                         range @input="range.length == 2  ? menus.date = false : menus.date = true"
          ></v-date-picker>
        </v-menu>
        <v-autocomplete v-if="!object" v-model="filter.object" clearable
                        :label="$vuetify.lang.t('$vuetify.selectObjectLabel')"
                        :items="selectObjects" item-text="name" item-value="id"
                        @change="loadData"
                        :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: 200,
                                      contentClass: 'select-menu select-menu--sort',
                                  }" outlined hide-details attach></v-autocomplete>
        <v-autocomplete v-if="(object || $route.path.includes('bookkeeping')) && permissions.admin" v-model="filter.worker"
                        clearable
                        :label="$vuetify.lang.t('$vuetify.accounting.card.worker')"
                        :items="workers" item-text="label" item-value="id"
                        @change="loadData"
                        :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: 200,
                                      contentClass: 'select-menu select-menu--sort',
                                  }" outlined hide-details attach>
          <template v-slot:selection="{ item }">
            {{ item.name }} {{ item.lastname }},
            <template v-if="item.position && item.position.name">
              ({{
                item.position.name[$vuetify.lang.current] ? item.position.name[$vuetify.lang.current] : item.position.name['eng'] ? item.position.name['eng'] : item.position.name['fin']
              }})
            </template>
          </template>
          <template v-slot:item="{ item }">
            {{ item.name }} {{ item.lastname }},
            <template v-if="item.position && item.position.name">
              ({{
                item.position.name[$vuetify.lang.current] ? item.position.name[$vuetify.lang.current] : item.position.name['eng'] ? item.position.name['eng'] : item.position.name['fin']
              }})
            </template>
          </template>
        </v-autocomplete>
        <div v-if="!$route.path.includes('bookkeeping')" class="sorts__radio">
          <span>{{ $vuetify.lang.t('$vuetify.dataTable.sortBy') }}</span>
          <div class="custom-radio">
            <input v-model="sort" type="radio" name="sort" value="position" id="position" class="custom-radio__hide"/>
            <label for="position" class="custom-radio__button"><span></span></label>
            <label for="position">{{ $vuetify.lang.t('$vuetify.sorts.byWorkType') }}</label>
          </div>
          <div class="custom-radio">
            <input v-model="sort" type="radio" name="sort" value="sum" id="sum" class="custom-radio__hide"/>
            <label for="sum" class="custom-radio__button"><span></span></label>
            <label for="sum">{{ $vuetify.lang.t('$vuetify.sorts.bySum') }}</label>
          </div>
        </div>
        <v-select v-if="!$route.path.includes('bookkeeping')" class="sorts__select" v-model="sort"
                  :label="$vuetify.lang.t('$vuetify.dataTable.sortBy')"
                  :items="selectSorts" item-text="name" item-value="value"
                  :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: 200,
                                      contentClass: 'select-menu select-menu--sort',
                                  }" outlined hide-details attach>
          <template v-slot:selection="{item }">
            {{ $vuetify.lang.t("$vuetify.sorts." + item.type) }}
            {{ $vuetify.lang.t("$vuetify." + item.direction) }}
          </template>
          <template v-slot:item="{ item }">
            {{ $vuetify.lang.t("$vuetify.sorts." + item.type) }}
            {{ $vuetify.lang.t("$vuetify." + item.direction) }}
          </template>
        </v-select>
      </div>
      <div class="page-head--right" v-if="$route.path.includes('bookkeeping') || object">
        <div class="type-switcher">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="type-switcher__item type-switcher__item--document" @click="createReport"
                   v-bind="attrs"
                   v-on="on">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.80036 13.2004C7.64123 13.2004 7.48862 13.2636 7.3761 13.3761C7.26358 13.4886 7.20036 13.6413 7.20036 13.8004V16.2004C7.20036 16.3595 7.26358 16.5121 7.3761 16.6247C7.48862 16.7372 7.64123 16.8004 7.80036 16.8004C7.95949 16.8004 8.1121 16.7372 8.22463 16.6247C8.33715 16.5121 8.40036 16.3595 8.40036 16.2004V16.0012H8.79996C9.17137 16.0012 9.52757 15.8536 9.7902 15.591C10.0528 15.3284 10.2004 14.9722 10.2004 14.6008C10.2004 14.2294 10.0528 13.8732 9.7902 13.6106C9.52757 13.3479 9.17137 13.2004 8.79996 13.2004H7.80036ZM8.79996 14.8012H8.40036V14.4004H8.79996C8.85311 14.4004 8.90409 14.4215 8.94167 14.4591C8.97925 14.4967 9.00036 14.5476 9.00036 14.6008C9.00036 14.6539 8.97925 14.7049 8.94167 14.7425C8.90409 14.7801 8.85311 14.8012 8.79996 14.8012Z"
                    fill="#2C1521"/>
                  <path
                    d="M14.4004 13.8004C14.4004 13.6413 14.4636 13.4886 14.5761 13.3761C14.6886 13.2636 14.8412 13.2004 15.0004 13.2004H16.2004C16.3595 13.2004 16.5121 13.2636 16.6246 13.3761C16.7371 13.4886 16.8004 13.6413 16.8004 13.8004C16.8004 13.9595 16.7371 14.1121 16.6246 14.2247C16.5121 14.3372 16.3595 14.4004 16.2004 14.4004H15.6004V14.8024H16.2004C16.3595 14.8024 16.5121 14.8656 16.6246 14.9781C16.7371 15.0906 16.8004 15.2433 16.8004 15.4024C16.8004 15.5615 16.7371 15.7141 16.6246 15.8267C16.5121 15.9392 16.3595 16.0024 16.2004 16.0024H15.6004V16.1992C15.6005 16.278 15.5852 16.356 15.5552 16.4289C15.5251 16.5017 15.4811 16.568 15.4255 16.6238C15.3132 16.7366 15.1607 16.8001 15.0016 16.8004C14.8424 16.8007 14.6897 16.7378 14.5769 16.6255C14.4642 16.5132 14.4007 16.3607 14.4004 16.2016V13.8004Z"
                    fill="#2C1521"/>
                  <path
                    d="M11.3992 13.2004C11.24 13.2004 11.0874 13.2636 10.9749 13.3761C10.8624 13.4886 10.7992 13.6413 10.7992 13.8004V16.2004C10.7992 16.3595 10.8624 16.5121 10.9749 16.6247C11.0874 16.7372 11.24 16.8004 11.3992 16.8004H12.0004C12.4778 16.8004 12.9356 16.6107 13.2732 16.2732C13.6107 15.9356 13.8004 15.4778 13.8004 15.0004C13.8004 14.523 13.6107 14.0652 13.2732 13.7276C12.9356 13.39 12.4778 13.2004 12.0004 13.2004H11.3992ZM11.9992 15.6004V14.4004H12.0004C12.1595 14.4004 12.3121 14.4636 12.4246 14.5761C12.5371 14.6886 12.6004 14.8413 12.6004 15.0004C12.6004 15.1595 12.5371 15.3121 12.4246 15.4247C12.3121 15.5372 12.1595 15.6004 12.0004 15.6004H11.9992Z"
                    fill="#2C1521"/>
                  <path
                    d="M4.80036 4.80039C4.80036 4.16387 5.05322 3.55342 5.50331 3.10333C5.95339 2.65325 6.56384 2.40039 7.20036 2.40039H12.7036C13.1808 2.40081 13.6383 2.59073 13.9756 2.92839L18.6736 7.62519C19.0112 7.96243 19.2011 8.41996 19.2016 8.89719V10.8988C19.552 11.0233 19.8553 11.2532 20.0698 11.557C20.2842 11.8609 20.3993 12.2237 20.3992 12.5956V17.3992C20.3992 17.7712 20.2839 18.1341 20.0693 18.438C19.8546 18.7419 19.551 18.9717 19.2004 19.096V19.2004C19.2004 19.8369 18.9475 20.4474 18.4974 20.8974C18.0473 21.3475 17.4369 21.6004 16.8004 21.6004H7.20036C6.56384 21.6004 5.95339 21.3475 5.50331 20.8974C5.05322 20.4474 4.80036 19.8369 4.80036 19.2004V19.096C4.44969 18.9717 4.14613 18.7419 3.93145 18.438C3.71678 18.1341 3.60153 17.7712 3.60156 17.3992V12.5956C3.60162 12.2234 3.71704 11.8604 3.93194 11.5565C4.14685 11.2526 4.45066 11.0229 4.80156 10.8988V4.80039H4.80036ZM18.0004 9.60039H13.8004C13.323 9.60039 12.8651 9.41075 12.5276 9.07318C12.19 8.73562 12.0004 8.27778 12.0004 7.80039V3.60039H7.20036C6.8821 3.60039 6.57688 3.72682 6.35183 3.95186C6.12679 4.17691 6.00036 4.48213 6.00036 4.80039V10.7956H18.0004V9.60039ZM6.00036 19.1992C6.00021 19.3569 6.03113 19.513 6.09136 19.6588C6.1516 19.8045 6.23996 19.9369 6.35141 20.0485C6.46286 20.16 6.5952 20.2486 6.74087 20.3089C6.88653 20.3693 7.04268 20.4004 7.20036 20.4004H16.8004C16.9581 20.4004 17.1142 20.3693 17.2599 20.3089C17.4055 20.2486 17.5379 20.16 17.6493 20.0485C17.7608 19.9369 17.8491 19.8045 17.9094 19.6588C17.9696 19.513 18.0005 19.3569 18.0004 19.1992H6.00036ZM13.2004 3.84879V7.80039C13.2004 7.95952 13.2636 8.11213 13.3761 8.22465C13.4886 8.33718 13.6412 8.40039 13.8004 8.40039H17.752L13.2004 3.84879ZM5.40156 11.9956C5.24243 11.9956 5.08982 12.0588 4.9773 12.1713C4.86478 12.2838 4.80156 12.4365 4.80156 12.5956V17.3992C4.80156 17.5583 4.86478 17.7109 4.9773 17.8235C5.08982 17.936 5.24243 17.9992 5.40156 17.9992H18.6004C18.7595 17.9992 18.9121 17.936 19.0246 17.8235C19.1372 17.7109 19.2004 17.5583 19.2004 17.3992V12.5956C19.2004 12.4365 19.1372 12.2838 19.0246 12.1713C18.9121 12.0588 18.7595 11.9956 18.6004 11.9956H5.40036H5.40156Z"
                    fill="#2C1521"/>
                </svg>
              </div>
            </template>
            <span>{{ $vuetify.lang.t('$vuetify.loadDoc') }}</span>
          </v-tooltip>
        </div>
      </div>
    </div>

    <div class="timing__statistic cards__single"
         v-if="$parent.type != 'client' ">
      <h3>{{ $vuetify.lang.t('$vuetify.statistic') }}</h3>
      <div class="statistic__table">
        <div class="statistic__column">
          <div class="bolder"> {{ $vuetify.lang.t('$vuetify.timings.tabs.hourly') }}</div>
          <div class="statistic__line">
            <span>{{ $vuetify.lang.t('$vuetify.hours') }}</span>
            <span>{{ statistic.hours ? statistic.hours.toFixed(2) : 0.00 }}</span></div>
          <div class="statistic__line">
            <span>{{ $vuetify.lang.t('$vuetify.accounting.card.sum') }}</span>
            <span>{{ statistic.sum_h ? statistic.sum_h.toFixed(2) : 0.00 }} €</span>
          </div>
        </div>
        <div class="statistic__column">
          <div class="bolder">{{ $vuetify.lang.t('$vuetify.timings.tabs.piecework') }}</div>
          <div class="statistic__line"></div>
          <div class="statistic__line">
            <span>{{ $vuetify.lang.t('$vuetify.accounting.card.sum') }}</span>
            <span>{{ statistic.sum_p ? statistic.sum_p.toFixed(2) : 0.00 }} €</span>
          </div>
        </div>
        <div class="statistic__column">
          <div class="bolder">{{ $vuetify.lang.t('$vuetify.timings.tabs.fixed') }}</div>
          <div class="statistic__line"></div>
          <div class="statistic__line">
            <span>{{ $vuetify.lang.t('$vuetify.accounting.card.sum') }}</span>
            <span>{{ statistic.sum_f ? statistic.sum_f.toFixed(2) : 0.00 }} €</span>
          </div>
        </div>
      </div>
      <div class="statistic__table">
        <div class="statistic__column">
          <div class="bolder"> {{ $vuetify.lang.t('$vuetify.accounting.statistic.count') }}</div>
          <div class="statistic__line statistic__sum">
            <span>{{ $vuetify.lang.t('$vuetify.accounting.card.sum') }}</span>
            <span>{{ statistic.sum ? statistic.sum.toFixed(2) : 0.00 }} €</span>
          </div>
        </div>
      </div>
    </div>

    <div class="profile-tabs timing-tabs cards__single">
      <div class="profile-tabs__head">
        <div class="profile-tabs__item" :class="{ selected: type == 'piecework' }" @click="type = 'piecework'">
          {{ $vuetify.lang.t('$vuetify.timings.tabs.piecework') }}
        </div>
        <div class="profile-tabs__item" :class="{ selected: type == 'hourly' }" @click="type = 'hourly'">
          {{ $vuetify.lang.t('$vuetify.timings.tabs.hourly') }}
        </div>
        <div class="profile-tabs__item" :class="{ selected: type == 'fixed' }" @click="type = 'fixed'">
          {{ $vuetify.lang.t('$vuetify.timings.tabs.fixed') }}
        </div>
      </div>
    </div>
    <table class="main-table">
      <thead class="timing-wrap timing__head">
      <td>{{ $vuetify.lang.t('$vuetify.date') }}</td>
      <td>{{ $vuetify.lang.t('$vuetify.workType') }}</td>
      <td v-if="!$route.path.includes('bookkeeping')">{{ $vuetify.lang.t('$vuetify.accounting.card.client') }}</td>
      <td v-if="!object">{{ $vuetify.lang.t('$vuetify.selectObjectLabel') }}</td>
      <td v-if="object || $route.path.includes('bookkeeping')">{{ $vuetify.lang.t('$vuetify.menu.workers-item') }}</td>
      <td v-if="type != 'fixed' && $parent.type != 'client'" class="flex flex-nowrap">
        {{ $vuetify.lang.t('$vuetify.wages.rate') }}
        <span v-if="type=='piecework'">/{{ $vuetify.lang.t('$vuetify.wages.measurement') }}</span>
        <v-icon v-if="!show" @click="show=true">mdi-eye</v-icon>
        <v-icon v-else @click="show=false">mdi-eye-off</v-icon>
      </td>
      <td v-if="type == 'piecework'">{{ $vuetify.lang.t('$vuetify.wages.measurement') }}</td>
      <td v-if="type == 'hourly'">{{ $vuetify.lang.t('$vuetify.time') }}</td>
      <td v-if="type == 'hourly'">{{ $vuetify.lang.t('$vuetify.wages.time') }}</td>
      <td class="timing__sum" v-if="type != 'fixed' && $parent.type != 'client'">
        {{ $vuetify.lang.t('$vuetify.wages.sum') }}
      </td>
      <th class="rows__dot-menu" v-if="$parent.type != 'client'">
        <v-icon v-if="!show" @click="show=true">mdi-eye</v-icon>
        <v-icon v-else @click="show=false">mdi-eye-off</v-icon>
      </th>
      </thead>
      <tbody>
      <tr class="timing-wrap rows__single" :class="{'mobile-show': item.id==notruncate&&type!='fixed'}"
          v-for="item in timings" :ref="'item'+item.id"
          :key="item.id" @click="truncate(item.id)">
        <td>{{ new Date(item.date).toLocaleDateString('ru-Ru') }}</td>
        <td class="timing__work">
          <div class="timing-pre__wrap" :class="{'truncate-text': item.id!==notruncate}"
               :style="'max-height: 100%; height:' + (item.id!==notruncate ? '60px' : (inHeight+'px'))">
            <pre v-if="translated.indexOf(item.id) === -1" :id="'item'+item.id">{{ item.position }}</pre>
            <pre v-else :id="'item'+item.id">{{ item.translated }}</pre>
          </div>
          <span v-if="translated.indexOf(item.id) === -1" class="link cp text-right" @click.stop="translateText(item)">
                          {{ $vuetify.lang.t("$vuetify.translate") }}
                        </span>
          <span v-else class="link cp text-right" @click.stop="translated.splice(translated.indexOf(item.id), 1)">
                          {{ $vuetify.lang.t("$vuetify.showOriginal") }}
                        </span>
        </td>
        <td v-if="!$route.path.includes('bookkeeping')">
          <template v-if="item.objects_id.client_id">
            <router-link v-if="permissions.admin || permissions.read.indexOf('Клиенты') != -1"
                         :to="'/clients/' + item.objects_id.client_id.id">
              {{ item.objects_id.client_id.name }}
            </router-link>
            <span v-else>{{ item.objects_id.client_id.name }}</span>
          </template>
        </td>
        <td v-if="!object">
          <router-link v-if="permissions.admin || permissions.read.indexOf('Объекты') != -1"
                       :to="'/objects/' + item.objects_id.id">
            {{ item.objects_id.name }}
          </router-link>
          <span v-else>{{ item.objects_id.name }}</span>
        </td>
        <td v-if="object || $route.path.includes('bookkeeping')">
          <router-link v-if="permissions.admin || permissions.read.indexOf('Работники') != -1"
                       :to="'/workers/' + item.user_profile_id.id">
            {{ item.user_profile_id.name }} {{ item.user_profile_id.lastname }}
          </router-link>
          <span v-else>{{ item.user_profile_id.name }} {{ item.user_profile_id.lastname }}</span>
        </td>
        <td v-if="type!='fixed' && $parent.type != 'client'" :class="{'blur-5': !show}"
            style="transition: 0.3s">
          {{ item.options.rate }}
          €<span v-if="type=='piecework'">/{{
            ($vuetify.lang.t('$vuetify.measurements.' + item.options.measurement)).length < 10 ? $vuetify.lang.t('$vuetify.measurements.' + item.options.measurement) : item.options.measurement
          }}
          </span><span v-if="type=='hourly'">/h</span>
        </td>
        <td v-if="type=='piecework'">
          {{ item.options.quantity }}
          {{
            ($vuetify.lang.t('$vuetify.measurements.' + item.options.measurement)).length < 10 ? $vuetify.lang.t('$vuetify.measurements.' + item.options.measurement) : item.options.measurement
          }}
        </td>
        <td v-if="type=='hourly'">
          <span v-if="item.time_start && item.time_end">
            {{ item.time_start.substring(0, 5) }} - {{ item.time_end.substring(0, 5) }}
          </span>
        </td>
        <td v-if="type=='hourly'">
          {{ item.options.hours ? item.options.hours.toFixed(2) : 0.00 }} h
        </td>
        <td class="timing__sum" v-if="type!='fixed' && $parent.type != 'client'">{{ item.sum }} €</td>
        <td class="rows__dot-menu" v-if="$parent.type != 'client'">
          <v-menu bottom right v-if="((worker == undefined && !item.approved) || permissions.admin) && active">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on">
                <svg
                  v-bind="attrs"
                  v-on="on"
                  width="20"
                  height="5"
                  viewBox="0 0 20 5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="2" cy="2.5" r="2" fill="#2C1521"/>
                  <circle cx="10" cy="2.5" r="2" fill="#2C1521"/>
                  <circle cx="18" cy="2.5" r="2" fill="#2C1521"/>
                </svg>
              </v-btn>
            </template>
            <div class="rows__dot-menu-content">
              <div class="btn-wrap"
                   @click="action='edit';timing_create_open(item)">
                {{ $vuetify.lang.t('$vuetify.edit') }}
                <button class="btn-icon btn-action">
                  <edit-icon></edit-icon>
                </button>
              </div>
              <div class="btn-wrap"
                   @click="confirm_open(item.id)">
                {{ $vuetify.lang.t('$vuetify.delete') }}
                <button class="btn-icon btn-action">
                  <delete-icon></delete-icon>
                </button>
              </div>
              <div class="btn-wrap" v-if="permissions.admin && !item.approved"
                   @click="action='edit';timing_approve_open(item)">
                {{ $vuetify.lang.t('$vuetify.confirm') }}
                <button class="btn-icon btn-action">
                  <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc" focusable="false"
                       aria-hidden="true" viewBox="0 0 24 24" data-testid="DoneOutlineIcon">
                    <path
                      d="m19.77 5.03 1.4 1.4L8.43 19.17l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 5.03m0-2.83L8.43 13.54l-4.2-4.2L0 13.57 8.43 22 24 6.43 19.77 2.2z"></path>
                  </svg>
                </button>
              </div>
              <div class="btn-wrap" v-if="permissions.admin"
                   @click="loadHistory(item.id)">
                {{ $vuetify.lang.t('$vuetify.history') }}
                <button class="btn-icon btn-action">
                  <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc" focusable="false"
                       aria-hidden="true" viewBox="0 0 24 24" data-testid="HistoryOutlinedIcon">
                    <path
                      d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z"></path>
                  </svg>
                </button>
              </div>
              <div class="btn-wrap" v-if="permissions.admin && (item.geo_start || item.geo_end)" @click="openGeo(item)">
                {{ $vuetify.lang.t('$vuetify.showGeo') }}
                <button class="btn-icon btn-action">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9ZM16.8 9C16.8 10.9778 15.7985 13.0015 14.4 14.4C13.0015 15.7985 10.9778 16.8 9 16.8C7.02224 16.8 4.99849 15.7985 3.6 14.4C2.20151 13.0015 1.2 10.9778 1.2 9C1.2 7.02224 2.20151 4.99849 3.6 3.6C4.99849 2.20151 7.02224 1.2 9 1.2C10.9778 1.2 13.0015 2.20151 14.4 3.6C15.7985 4.99849 16.8 7.02224 16.8 9Z"
                          fill="#2C1521"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M5.14286 9.00001C5.14286 13.6512 6.67646 17.4857 9 17.4857C11.3235 17.4857 12.8571 13.6512 12.8571 9.00001C12.8571 4.34881 11.3235 0.514291 9 0.514291C6.67646 0.514291 5.14286 4.34881 5.14286 9.00001ZM11.6603 9.00001C11.6603 12.8695 10.0851 16.29 9 16.29C7.91486 16.29 6.34028 12.8695 6.34028 9.00001C6.34028 5.13052 7.91486 1.71001 9 1.71001C10.0851 1.71001 11.6603 5.13052 11.6603 9.00001Z"
                          fill="#2C1521"/>
                    <path
                      d="M2.41908 4.3375L3.45383 3.19373C3.55668 3.2863 3.6688 3.37887 3.78811 3.46835C5.09543 4.44755 7.1824 5.39 9.46068 5.39C11.4057 5.39 13.217 4.61315 14.5326 3.86127C14.8494 3.68024 15.1312 3.48378 15.375 3.27498L16.3768 4.44858C16.0579 4.72115 15.6969 4.97315 15.2989 5.19944C13.7395 6.09224 11.6639 6.59418 9.46068 6.59418C6.86663 6.59418 4.45669 5.89681 2.8624 4.70264C2.7091 4.5878 2.56117 4.46596 2.41908 4.3375Z"
                      fill="#2C1521"/>
                    <path
                      d="M2.41908 13.679L3.45383 14.8227C3.55668 14.7291 3.6688 14.6376 3.78811 14.5481C5.09543 13.5689 7.1824 12.61 9.46068 12.61C11.4057 12.61 13.217 13.4033 14.5326 14.1552C14.8494 14.3362 15.1312 14.5327 15.375 14.7415L16.3768 13.5679C16.0417 13.2845 15.6808 13.0331 15.2989 12.817C13.7395 11.9242 11.6639 11.4223 9.46068 11.4223C6.86663 11.4223 4.45669 12.1196 2.8624 13.3138C2.7091 13.4287 2.56117 13.5505 2.41908 13.679Z"
                      fill="#2C1521"/>
                    <path d="M1 9.6V8.4H17V9.6H1Z" fill="#2C1521"/>
                  </svg>
                </button>
              </div>
            </div>
          </v-menu>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="page-footer">
      <per-page-select v-model="perPage" :per-page-select="[50, 100, 150, 200]"></per-page-select>
      <v-pagination
        v-model="page"
        :length="length"
        @input="loadData"
      ></v-pagination>
    </div>

    <v-dialog v-model="timing_create_modal">
      <div class="modal">
        <div class="h1">
          <span v-if="action == 'add'">{{ $vuetify.lang.t('$vuetify.addTimeReport') }}</span><span
          v-if="action == 'edit'">{{ $vuetify.lang.t('$vuetify.editTimeReport') }}</span>
        </div>
        <v-form ref="form" @submit.prevent="addTiming" onkeydown="return event.key != 'Enter';">
          <v-checkbox v-if="permissions.admin" v-model="newTiming.approved"
                      :label="$vuetify.lang.t('$vuetify.confirm')"></v-checkbox>
          <v-menu ref="menuEnd" v-model="dateMenu" :close-on-content-click="false" transition="scale-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :value="new Date(newTiming.date).toLocaleDateString('ru-Ru')"
                            :label="$vuetify.lang.t('$vuetify.date')" append-icon="$calendar" v-bind="attrs" v-on="on"
                            outlined readonly :rules="[$rules.required]">
              </v-text-field>
            </template>
            <v-date-picker v-model="newTiming.date" @input="dateMenu = false" :allowed-dates="allowedDates"
                           no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                           show-adjacent-months></v-date-picker>
          </v-menu>
          <v-textarea :label="$vuetify.lang.t('$vuetify.workType')" v-model="newTiming.position"
                      :rules="[$rules.required]" outlined></v-textarea>
          <v-autocomplete :label="$vuetify.lang.t('$vuetify.selectObjectLabel')" v-model="newTiming.objects_id"
                          :items="objects" item-text="name" item-value="id"
                          :rules="[$rules.required]" outlined attach
                          :menu-props="{
              bottom: true,
              offsetY: true,
              maxHeight: width<1024 ? 200 : 800,
              contentClass: 'select-menu',
            }"></v-autocomplete>
          <v-select v-model="newTiming.type" class="custom" :label="$vuetify.lang.t('$vuetify.wages.label')"
                    :items="wagesType" item-text="name" item-value="value" outlined attach
                    :menu-props="{
              bottom: true,
              offsetY: true,
              maxHeight: width<1024 ? 200 : 800,
              contentClass: 'select-menu',
            }" :rules="[$rules.required]">
            <template v-slot:selection="{ item }">
              {{ $vuetify.lang.t('$vuetify.wages.' + item.value) }}
            </template>
            <template v-slot:item="{ item }">
              {{ $vuetify.lang.t('$vuetify.wages.' + item.value) }}
            </template>
          </v-select>
          <div v-if="newTiming.type == 'piecework'">
            <v-text-field v-model="newTiming.options.rate" :label="$vuetify.lang.t('$vuetify.wages.rate')"
                          outlined type="number"
                          :rules="[$rules.required, $rules.positiveNumbers]"></v-text-field>
            <div class="form__row">
              <v-text-field v-model.number="newTiming.options.quantity" type="number"
                            :label="$vuetify.lang.t('$vuetify.wages.quantity')"
                            outlined :rules="[$rules.required, $rules.positiveNumbers]"></v-text-field>
              <v-combobox v-model="newTiming.options.measurement" class="custom"
                          :label="$vuetify.lang.t('$vuetify.wages.measurement')"
                          :items="measurements" item-text="name" item-value="value" outlined attach
                          :menu-props="{
                          bottom: true,
                          offsetY: true,
                          maxHeight: width<1024 ? 200 : 800,
                          contentClass: 'select-menu',
                        }" :rules="[$rules.required]">
                <template v-slot:item="{ item }">
                  {{
                    $vuetify.lang.t('$vuetify.measurements.' + item) ? $vuetify.lang.t('$vuetify.measurements.' + item) : item
                  }}
                </template>
              </v-combobox>
            </div>
          </div>
          <div v-if="newTiming.type == 'hourly'">
            <v-text-field v-model.number="newTiming.options.rate" :label="$vuetify.lang.t('$vuetify.wages.rate')"
                          outlined
                          :rules="[$rules.required, $rules.positiveNumbers]"></v-text-field>
            <div class="form__row">
              <v-menu ref="menuStartTime" v-model="menus.timeStartMenu"
                      :close-on-content-click="false" :nudge-right="40"
                      :return-value.sync="newTiming.time_start"
                      transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="newTiming.time_start"
                                :label="$vuetify.lang.t('$vuetify.accounting.card.time_start')" readonly v-bind="attrs"
                                v-on="on" outlined :rules="[$rules.required]"></v-text-field>
                </template>
                <v-time-picker v-if="menus.timeStartMenu" v-model="newTiming.time_start" full-width
                               format="24hr" :allowed-minutes="allowedMinutes"
                               @click:minute="$refs.menuStartTime.save(newTiming.time_start)"></v-time-picker>
              </v-menu>
              <v-menu ref="menuEndTime" v-model="menus.timeEndMenu" :close-on-content-click="false"
                      :nudge-right="40" :return-value.sync="newTiming.time_end" transition="scale-transition"
                      offset-y min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="newTiming.time_end"
                                :label="$vuetify.lang.t('$vuetify.accounting.card.time_end')" readonly v-bind="attrs"
                                v-on="on" outlined :rules="[$rules.required]"></v-text-field>
                </template>
                <v-time-picker v-if="menus.timeEndMenu" v-model="newTiming.time_end" full-width format="24hr"
                               :min="newTiming.time_start" :allowed-minutes="allowedMinutes"
                               @click:minute="$refs.menuEndTime.save(newTiming.time_end)"></v-time-picker>
              </v-menu>
            </div>
            <v-select v-model="newTiming.options.pause" class="custom"
                      :label="$vuetify.lang.t('$vuetify.pause')"
                      :items="selectPause" item-text="name" item-value="value" outlined attach
                      :menu-props="{
              bottom: true,
              offsetY: true,
              maxHeight: 200,
              contentClass: 'select-menu',
            }">
              <template v-slot:selection="{item }">
                {{ item.value }} {{ $vuetify.lang.t('$vuetify.minutes') }}
              </template>
              <template v-slot:item="{ item }">
                {{ item.value }} {{ $vuetify.lang.t('$vuetify.minutes') }}
              </template>
            </v-select>
            <v-select v-model="newTiming.options.trip_time" class="custom"
                      :label="$vuetify.lang.t('$vuetify.tripTime')"
                      :items="trips" item-text="name" item-value="minutes" outlined attach
                      :menu-props="{
              bottom: true,
              offsetY: true,
              maxHeight: 200,
              contentClass: 'select-menu',
            }">
              <template v-slot:selection="{item }">
                <template v-if="Math.floor(item.minutes / 60) > 0">
                  {{ Math.floor(item.minutes / 60) }} {{ $vuetify.lang.t('$vuetify.hour') }}
                </template>
                {{ item.minutes % 60 }} {{ $vuetify.lang.t('$vuetify.minutes') }}
              </template>
              <template v-slot:item="{ item }">
                <template v-if="Math.floor(item.minutes / 60) > 0">
                  {{ Math.floor(item.minutes / 60) }} {{ $vuetify.lang.t('$vuetify.hour') }}
                </template>
                {{ item.minutes % 60 }} {{ $vuetify.lang.t('$vuetify.minutes') }}
              </template>
            </v-select>
          </div>
          <div class="timing-form__salary">
            {{ $vuetify.lang.t('$vuetify.wages.sum') }}: {{ sum }}
          </div>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <div class="btn btn-secondary" @click.stop="timing_create_close">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </div>
            <button class="btn btn-primary">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
    <v-dialog v-model="history_modal" max-width="800">
      <div class="modal" style="width: 100% !important">
        <div class="h1">
          {{ $vuetify.lang.t('$vuetify.history') }}
        </div>
        <table class="history" style="width: 100%">
          <thead>
          <tr>
            <th> {{ $vuetify.lang.t('$vuetify.date') }}</th>
            <th> {{ $vuetify.lang.t('$vuetify.author') }}</th>
            <th> {{ $vuetify.lang.t('$vuetify.beforeChanges') }}</th>
            <th> {{ $vuetify.lang.t('$vuetify.afterChanges') }}</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="line in history">
            <tr :key="line.id" class="rows__single">
              <td>{{ new Date(line.datetime).toLocaleDateString('ru-Ru') }}
                {{ new Date(line.datetime).toLocaleTimeString('ru-Ru').substring(0, 5) }}
              </td>
              <td>{{ line.author.name }} {{ line.author.lastname }}</td>
              <td>
                {{ $vuetify.lang.t('$vuetify.wages.rate') }} {{ line.old.options.rate }}€ <br>
                {{ line.old.time_start.substring(0, 5) }}-{{ line.old.time_end.substring(0, 5) }}

              </td>
              <td>
                {{ $vuetify.lang.t('$vuetify.wages.rate') }} {{ line.changes.options.rate }}€ <br>
                {{ line.changes.time_start.substring(0, 5) }}-{{ line.changes.time_end.substring(0, 5) }}
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </v-dialog>
    <v-dialog v-model="geolocationModal" max-width="800">
      <div class="modal" style="width: 100% !important">
        <div class="h1">
          {{ $vuetify.lang.t('$vuetify.showGeo') }}
        </div>
        <div>
          <a v-if="geolocation.geo_start" target="_blank"
             :href="'https://www.google.com/maps/search/?api=1&query='+ geolocation.geo_start">
            {{ $vuetify.lang.t("$vuetify.accounting.card.time_start") }}
          </a>
        </div>
        <div>
          <a v-if="geolocation.geo_end" target="_blank"
             :href="'https://www.google.com/maps/search/?api=1&query='+ geolocation.geo_end">
            {{ $vuetify.lang.t("$vuetify.accounting.card.time_end") }}
          </a>
        </div>
      </div>
    </v-dialog>

    <ConfirmModal v-model="confirm_modal" @confirm="deleteTiming">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>

    <SpinnerLoader :overlay="loader"></SpinnerLoader>
  </div>
</template>

<script>
import ConfirmModal from "@/components/confirmModal";
import EditIcon from "@/components/icons/EditIcon";
import DeleteIcon from "@/components/icons/DeleteIcon";
import SpinnerLoader from "@/components/SpinnerLoader";
import PerPageSelect from "@/components/PerPageSelect.vue";
import {mapGetters} from "vuex";
import BookkeepingSelect from "@/components/BookkeepingSelect.vue";

export default {
  name: "TimingList",
  components: {BookkeepingSelect, PerPageSelect, SpinnerLoader, DeleteIcon, EditIcon, ConfirmModal},
  props: {
    worker: [Number, String, undefined],
    object: [Number, String, undefined]
  },
  data() {
    return {
      name: "",
      type: 'hourly',
      sort: '',
      filter: {
        object: 0,
        worker: 0,
      },
      page: 1,
      perPage: 50,
      length: 0,

      timings: [],
      objects: [],
      selectObjects: [],
      workers: [],
      positions: [],
      trips: [],
      statistic: {},
      period: false,
      selectSorts: [
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byObjects'),
          type: "byObjects",
          direction: "sortAscending", value: 'objects'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byWorkType'),
          type: "byWorkType",
          direction: "sortAscending", value: 'position'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.bySum'),
          type: "bySum",
          direction: "sortAscending", value: 'sum'
        },
      ],
      range: [
        new Date(new Date().setDate(1)).toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ],
      action: '',
      timing_create_modal: false,
      newTiming: {
        options: {},
      },
      dateMenu: false,
      wagesType: [
        {name: this.$vuetify.lang.t('$vuetify.wages.piecework'), value: 'piecework'},
        {name: this.$vuetify.lang.t('$vuetify.wages.hourly'), value: 'hourly'},
        {name: this.$vuetify.lang.t('$vuetify.wages.fixed'), value: 'fixed'},
      ],
      selectPause: [
        {name: '0 ' + this.$vuetify.lang.t('$vuetify.minutes'), value: 0},
        {name: '15 ' + this.$vuetify.lang.t('$vuetify.minutes'), value: 15},
        {name: '30 ' + this.$vuetify.lang.t('$vuetify.minutes'), value: 30},
        {name: '1 ' + this.$vuetify.lang.t('$vuetify.hour'), value: 60},
      ],
      measurements: [
        'kg',
        'g',
        'm',
        'm2',
        'm3',
        'pc',
      ],
      menus: {
        date: false,
        timeStartMenu: false,
        timeEndMenu: false
      },
      notruncate: 0,
      inHeight: 0,
      history: [],
      history_modal: false,

      geolocationModal: false,
      geolocation: {
        geo_start: "",
        geo_end: "",
      },
      translated: [],

      tmp_delete: 0,
      confirm_modal: false,
      alertError: false,
      alertMsg: "",
      loader: false,
      width: screen.width,
      show: false
    }
  },

  watch: {
    type: function () {
      this.loadData()
    },
    sort: function () {
      this.loadData()
    },
    range: function () {
      if (this.range.length == 2) //|| !this.period
        this.loadData()
    },
    perPage: function () {
      if ((this.page * this.perPage) > (this.page * this.history.length))
        this.page = 1
      this.loadData()
    },
  },

  computed: {
    ...mapGetters(['permissions']),
    ...mapGetters(['active']),
    sum: function () {
      let val = this.newTiming.options.rate * (this.newTiming.options.quantity || this.hours)
      if (val)
        return Number(val.toFixed(2))
      else
        return '- - -'
    },
    hours: function () {
      if (this.newTiming.time_end && this.newTiming.time_start) {
        let getDate = (string) => new Date(0, 0, 0, string.split(':')[0], string.split(':')[1]); //получение даты из строки (подставляются часы и минуты
        let different = (getDate(this.newTiming.time_end) - getDate(this.newTiming.time_start)) - (this.newTiming.options.pause ?? 0) * 60000 + (this.newTiming.options.trip_time ?? 0) * 60000;

        return (different % 86400000) / 3600000
      } else return 0
    }
  },

  created: function () {
    if (this.worker)
      this.url = "time-tracking/profiles/time-reports/" + this.worker
    else if (this.object)
      this.url = "time-tracking/objects/time-reports/" + this.object
    else if (this.$route.path.includes('bookkeeping'))
      this.url = "time-tracking/profiles/time-reports/all"
    else
      this.url = "time-tracking/time-reports"
    this.loadData()
    if (this.$parent.type != 'client') {
      this.loadObjects()
      this.loadPositions()
      this.loadTripTime()
      if (this.object)
        this.loadObjectWorkers()
      if (this.$route.path.includes('bookkeeping')) {
        this.loadWorkers()
        this.loadSelectObjects()
      }
    }
  },

  methods: {
    allowedDates: val => val <= new Date().toISOString(),
    allowedMinutes: v => v % 5 == 0,

    loadData() {
      this.loader = true
      this.$axios({
        url: this.$hostname + this.url,
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          type: this.type,
          sort: this.sort,
          range: JSON.stringify(this.range),
          filter: JSON.stringify(this.filter),
          page: this.page,
          per: this.perPage
        },
      }).then((response) => {
        this.timings = response.data.data.data
        this.name = response.data.data.name
        this.statistic = response.data.data.statistic
        this.timings.forEach(item => {
          item.sum = (item.options.rate * (item.options.quantity || item.options.hours)).toFixed(2)
        })
        if (response.data.data.objects) {
          this.objects = response.data.data.objects
        }
        this.length = response.data.data.pages
      }).catch((response) => {

        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).then(() => {
        this.loader = false
      })
    },
    loadObjects() {
      this.$axios({
        url: this.$hostname + "time-tracking/time-reports/objects" + (this.worker ? ('/' + this.worker) : ''),
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        }
      }).then((response) => {
        this.objects = response.data.data.data
        if (this.worker || (!this.$route.path.includes('bookkeeping') && !this.object)) {
          this.selectObjects = response.data.data.data
        }
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadSelectObjects() {
      this.$axios({
        url: this.$hostname + "time-tracking/accounting/objects",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        }
      }).then((response) => {
        this.selectObjects = response.data.data.data
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadPositions() {
      this.$axios({
        url: this.$hostname + "time-tracking/time-reports/positions",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.positions = response.data.data.positions
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadWorkers() {
      this.$axios({
        url: this.$hostname + "time-tracking/profiles/active",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          this.workers = response.data.data.data;
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    loadObjectWorkers() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects/employees/" + this.object,
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          this.workers = response.data.data.data;
          this.workers.forEach((worker) => {
            worker.id = worker.user_profile_id.id
            worker.name = worker.user_profile_id.name
            worker.lastname = worker.user_profile_id.lastname
            worker.position = worker.user_profile_id.position;

          });
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);

          this.alertError = true;
        });
    },
    loadTripTime() {
      this.$axios({
        url: this.$hostname + "time-tracking/trip-time",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.trips = response.data.data.data
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadHistory(id) {
      this.loader = true
      this.$axios({
        url: this.$hostname + 'time-tracking/history',
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          table: 'TimeReport',
          entity: id,
        },
      }).then((response) => {
        this.history = response.data.data.data
        this.history_modal = true
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).then(() => {
        this.loader = false
      })
    },

    addTiming() {
      if (this.$refs.form.validate()) {
        if (this.newTiming.time_end && this.newTiming.time_start) {
          this.newTiming.options.hours = this.hours
        }
        if (this.newTiming.options.quantity == "") {
          delete this.newTiming.options.quantity
        }
        if (this.newTiming.id) {
          this.putTiming()
        } else {
          this.newTiming.options = JSON.stringify(this.newTiming.options)
          if (this.worker) {
            this.newTiming.user_profile_id = this.worker
          }
          this.$axios({
            url: this.$hostname + "time-tracking/time-reports",
            method: "POST",
            headers: {
              Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
              "Content-Type": "multipart/form-data",
            },
            data: this.newTiming,
          }).then(() => {
            this.loadData()
            this.loadPositions()
            this.timing_create_close()
          }).catch((response) => {
            this.newTiming.options = JSON.parse(this.newTiming.options)
            this.alertMsg = this.$catch(response)
            this.alertError = true
          })
        }
      } else {
        this.alertMsg = "Заполните все обязательные поля"
        this.alertError = true
      }
    },
    putTiming() {
      this.newTiming.options = JSON.stringify(this.newTiming.options)
      this.$axios({
        url: this.$hostname + "time-tracking/time-reports",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newTiming,
      }).then(() => {
        this.loadData()
        this.loadPositions()
        this.timing_create_modal = false
      }).catch((response) => {
        this.newTiming.options = JSON.parse(this.newTiming.options)
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    deleteTiming() {
      this.$axios({
        url: this.$hostname + "time-tracking/time-reports",
        method: "DELETE",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {id: this.tmp_delete},
      }).then(() => {
        this.loadData()
        this.loadPositions()
        this.confirm_modal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    timing_create_open(item = null) {
      this.timing_create_modal = true;
      this.alertError = false

      if (this.action == "edit") {
        this.newTiming = item
      } else {
        this.newTiming = {
          date: (new Date(Date.now()).toISOString()).substr(0, 10),
          position: '',
          objects_id: '',
          type: '',
          options: {},
          user_profile_id: null,
        };
      }
    },
    timing_approve_open(item = null) {
      this.timing_create_modal = true;
      this.alertError = false
      this.newTiming = item
      this.newTiming.approved = true
    },
    timing_create_close() {
      this.timing_create_modal = false;
    },
    confirm_open(id) {
      this.tmp_delete = id
      this.confirm_modal = true
    },

    clearFilters() {
      this.range = []
      this.filter.object = 0
      this.filter.worker = 0
      this.loadData()
    },

    createReport() {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/time-reports/pdf",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          type: this.type,
          sort: this.sort,
          range: JSON.stringify(this.range),
          filter: JSON.stringify({
            worker:  this.worker ? this.worker : this.filter.worker,
            object: this.object ? this.object : this.filter.object
          })
        },
      }).then((response) => {
        let path = response.data.data.data
        var link = document.createElement('a')
        link.href = this.$media_url + path
        link.target = "_blank"
        document.body.appendChild(link);
        link.click()
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).then(() => {
        this.loader = false
      })
    },
    truncate(id) {
      let text = document.getElementById('item' + id)
      this.notruncate = this.notruncate == id ? 0 : id
      this.inHeight = text.clientHeight
    },

    openGeo(item) {
      this.geolocation = {
        geo_start: item.geo_start,
        geo_end: item.geo_end,
      }
      this.geolocationModal = true
    },

    translateText(timing) {
      this.translated.push(timing.id)
      this.$axios({
        url: "https://translation.googleapis.com/language/translate/v2?key=AIzaSyCcA3--66Nt9HiqrZeamki4_ZcG1KeJOL0",
        method: "POST",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        params: {
          q: timing.position,
          target: this.$vuetify.lang.current === "est" ? "et" : this.$vuetify.lang.current.substr(0, 2),
        }
      })
        .then((response) => {
          timing.translated = response.data.data.translations[0].translatedText
          this.$forceUpdate()
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
  },



}
</script>

<style scoped>
.page-head ~ .btn {
  margin-bottom: 10px;
}
</style>